import React from "react";
import { TMapRef, TMapRefGeozones } from "../../pages/map-fleet/type";
import { APP_CONFIG } from "../../constants/constants";
import { useSelector } from "react-redux";
import { TMapState } from "../../types/map";

type TMapZoomControlProps = {
  mapRef: React.RefObject<TMapRef> | React.RefObject<TMapRefGeozones>;
};

const MapZoomControl: React.FC<TMapZoomControlProps> = ({ mapRef }) => {
  const mapZoomForControls = useSelector(
    (state: { commonReducer: { mapZoomForControls: number } }) =>
      state.commonReducer.mapZoomForControls
  );

  return (
    <div
      id="ZoomControl"
      className="absolute right-0 top-full my-2 h-16 w-8 rounded-md bg-white shadow-md flex flex-col items-center justify-center overflow-hidden"
    >
      <button
        id="ZoomInButton"
        className="w-8 h-8 bg-white rounded-tl-md rounded-tr-md shadow-md flex items-center justify-center enabled:hover:bg-slate-100 disabled:bg-slate-300"
        type="button"
        role="button"
        onClick={() => {
          const newZoom = Math.min(
            mapRef?.current?.map.getZoom() + 1,
            APP_CONFIG.MAPS.ZOOM_MAX
          );
          mapRef?.current?.map.setZoom(newZoom);
        }}
        disabled={mapZoomForControls === APP_CONFIG.MAPS.ZOOM_MAX}
      >
        <div
          className="flex-1 w-4 h-4 bg-contain bg-center bg-no-repeat gm-zoom-in-icon"
          title="Zoom in"
        ></div>
      </button>
      <div className="zoom_divider border-t border-t-black/10"></div>
      <button
        id="ZoomOutButton"
        className="w-8 h-8 bg-white rounded-bl-md rounded-br-md shadow-md flex items-center justify-center enabled:hover:bg-slate-100 disabled:bg-slate-300"
        type="button"
        role="button"
        onClick={() => {
          const newZoom = Math.max(
            mapRef?.current?.map.getZoom() - 1,
            APP_CONFIG.MAPS.ZOOM_MIN
          );
          mapRef?.current?.map.setZoom(newZoom);
        }}
        disabled={mapZoomForControls === APP_CONFIG.MAPS.ZOOM_MIN}
      >
        <div
          className="flex-1 w-4 h-4 bg-contain bg-center bg-no-repeat gm-zoom-out-icon"
          title="Zoom out"
        ></div>
      </button>
    </div>
  );
};
export default MapZoomControl;
